import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { DeleteAccountDialogModule } from '@libs/src/delete-account-dialog/delete-account-dialog.module';
import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { VisibleGroupsModule } from '@main-client/src/app/core/visible-groups.module';
import { AccountFullNamePipeModule } from '@main-client/src/app/pipes/account-full-name-pipe/account-full-name-pipe.module';
import { AccountGeoLocationAddressPipeModule } from '@main-client/src/app/pipes/account-geo-location-address-pipe/account-geo-location-address-pipe.module';
import { AccountJobTitlePipeModule } from '@main-client/src/app/pipes/account-job-title-pipe/account-job-title-pipe.module';
import { AccountOrganizationNamePipeModule } from '@main-client/src/app/pipes/account-organization-name-pipe/account-organization-name-pipe.module';
import { DisplayUserPronounsPipeModule } from '@main-client/src/app/pipes/display-user-pronouns-pipe/display-user-pronouns.pipe.module';
import { LinkifyPipeModule } from '@main-client/src/app/pipes/linkify-pipe/linkify-pipe.module';
import { ProfileFormDialogHeadlineModule } from '@main-client/src/app/profile-form-dialogs/profile-form-headline/profile-form-dialog-headline.module';
import { ProfileActionModule } from '@main-client/src/app/profile/profile-action/profile-action.module';
import { ProfileIntroEditDialogModule } from '@main-client/src/app/profile/profile-intro-edit-dialog/profile-intro-edit-dialog.module';
import { ProfileIntroMenuModule } from '@main-client/src/app/profile/profile-intro-menu/profile-intro-menu.module';
import { ProfileReportDialogModule } from '@main-client/src/app/profile/profile-report-doalog/profile-report-dialog.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';
import { DialogImageUploadModule } from '@main-client/src/app/upload/dialog-image-upload/dialog-image-upload.module';

import { ProfileService } from '@main-client/src/app/profile/profile.service';

import { ProfileIntroComponent } from '@main-client/src/app/profile/profile-intro/profile-intro.component';

@NgModule({
  imports: [
    AccountFullNamePipeModule,
    AccountGeoLocationAddressPipeModule,
    AccountJobTitlePipeModule,
    AccountOrganizationNamePipeModule,
    AvatarModule,
    CommonModule,
    DeleteAccountDialogModule,
    DialogConfirmPromptModule,
    DialogImageUploadModule,
    DisplayUserPronounsPipeModule,
    FlexLayoutModule,
    LinkifyPipeModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    ProfileActionModule,
    ProfileFormDialogHeadlineModule,
    ProfileIntroEditDialogModule,
    ProfileIntroMenuModule,
    ProfileReportDialogModule,
    ProgressSpinnerModule,
    RouterModule,
    ToastModule,
    VisibleGroupsModule,
  ],
  declarations: [ProfileIntroComponent],
  exports: [ProfileIntroComponent],
  providers: [ProfileService],
})
export class ProfileIntroModule {}
